import React from "react";
import clsx from "clsx";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import parseData from "../../../../../../components/texts/parseData";
import {useOverviewTableStyles} from "../../../../../../common/styles/mandateOverviewContainerStyles";

const useStyles = useOverviewTableStyles;

const tableHeadings = ["", "Requirement", "Allocated", "Remaining"];

// const tableRows = new Array(10).fill(tableRow);

interface Props {
  construction_quantities_hvo: any;
  construction_quantities_fame: any;
  construction_quantities_etanol: any;
  construction_quantities_nafta: any;
}

const OverviewTableConstruction: React.FC<Props> = ({
  construction_quantities_hvo,
  construction_quantities_fame,
  construction_quantities_etanol,
  construction_quantities_nafta,
}) => {
  const classes = useStyles();

  const rows =
    construction_quantities_hvo && construction_quantities_fame
      ? [
          {
            title: "CARD Requirement FAME (L)",
            ...construction_quantities_fame,
          },
          {
            title: "CARD Requirement HVO (L)",
            ...construction_quantities_hvo,
          },
          {
            title: "CARD Requirement Etanol (L)",
            ...construction_quantities_etanol,
          },
          {
            title: "CARD Requirement Nafta (L)",
            ...construction_quantities_nafta,
          },
        ]
      : [];

  const parseVal = (value: number) => {
    let parsed = value;
    if (parsed) {
      if (value > -1 && value < 0) { parsed *= -1; }
      return parseData(parsed, 0);
    } else { return parsed; }
  };

  const getStatus = (remaining: any) => {
    if (remaining > 0) { return "Not Complete"; }
    if (remaining < 0) { return "Overallocated"; }
    return "Complete";
  };

  return (
    <div className={classes.tableContainer}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {tableHeadings.map((heading, hidx) => (
              <TableCell key={hidx}>{heading}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, ridx) => (
            <TableRow
              key={ridx}
              className={clsx({
                [classes.green]: getStatus(row.remaining) === "Complete",
                [classes.red]: getStatus(row.remaining) === "Not Complete",
                [classes.yellow]: getStatus(row.remaining) === "Overallocated",
              })}
            >
              <TableCell variant="head">{row.title}</TableCell>
              <TableCell>{parseVal(row.requirement)}</TableCell>
              <TableCell>{parseVal(row.allocated)}</TableCell>
              <TableCell>{parseVal(row.remaining)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default OverviewTableConstruction;
